import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { DFormHelpers } from './d-form.helpers';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, DoCheck, ChangeDetectorRef } from '@angular/core';
import { STRING, INPUT_TYPE, FORM_TYPE } from '../types';
import { FormGroup, FormBuilder } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { DFormGroupComponent } from '../d-form-group/d-form-group.component';
import { FORM_STYLE_CONFIG } from './style.config';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-d-form',
	templateUrl: './d-form.component.html',
	styleUrls: ['./d-form.component.css']
})
export class DFormComponent implements OnInit, DoCheck {
	@Input() formElements: any[];
	@Input() name = '';
	@Input() label = '';
	@Input() formRef: FormGroup;
	@Input() type: string;
	@Input() disable: boolean;
	@Input() options = {
		withElementPadding: false
	};
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	@Output() formRefChange = new EventEmitter();
	@Output() change = new EventEmitter();
	@Output() formBuildCompleted = new EventEmitter();
	elementClass: any = '';
	formBuildComplete = false;
	testing =
		environment.functionalities && environment.functionalities.formTest; // TESTING
	appFormGroup: FormGroup;
	temp = {};
	value = {};
	INPUT_TYPE = INPUT_TYPE;
	constructor(private formBuilder: FormBuilder, private cdr: ChangeDetectorRef) {}

	get FORM_TYPE() {
		return FORM_TYPE;
	}
	createFormGroupObject(formElements: any[]) {
		const group = {};
		for (const formElement of formElements) {
			const validations = DFormHelpers.createValidations(
				formElement,
				this.disable
			);
			if (formElement.lastElement) {
				this.formBuildComplete = true;
			}
			group[formElement.name] = [null, validations];
		}
		return group;
	}

	private _formatView() {
		if (this.options) {
			if (this.options.withElementPadding) {
				this.elementClass = 'form-element-padding';
			}
		}
	}

	ngOnInit() {
		this._formatView();
		this.appFormGroup = this._createFormGroup(this.formElements);
		this.formRef = this.appFormGroup;
		this.formRefChange.emit(this.formRef);
		if (this.formBuildComplete) {
			this.formBuildCompleted.emit();
			this.formBuildComplete = false;
		}
	}

	onTest() {
		console.log(Helpers.copyObj(this.formRef));
		console.log(Helpers.copyObj(DFormGroupComponent.getValue(this.formRef)));
		console.log('test');
	}

	// clearValidator(formControlName) {
	// 	this.appFormGroup.get(formControlName).clearValidators();
	// 	this.appFormGroup.controls[formControlName].updateValueAndValidity();
	// }

	// setValidator(formControlName, validators = []) {
	// 	this.appFormGroup.get(formControlName).setValidators(validators);
	// 	this.appFormGroup.controls[formControlName].updateValueAndValidity();
	// }

	// resetValidator(formControlName, validators = []) {
	// 	this.clearValidator(formControlName);
	// 	this.setValidator(formControlName, validators);
	// }

	// private _runEvent(formElement, eventName) {
	// 	const value = this.value[formElement.name];
	// 	if (!formElement || !formElement[eventName]) {
	// 		return;
	// 	}
	// 	if (!(typeof formElement[eventName] === 'function')) {
	// 		return console.warn(
	// 			`${eventName} of element <<${
	// 				formElement.name
	// 			}>> is not a function !`
	// 		);
	// 	}
	// 	return value;
	// }

	// private _runOnChangeElement(formElement) {
	// 	const value = this._runEvent(formElement, 'onChange');
	// 	if (value === undefined) {
	// 		return;
	// 	}
	// 	formElement.onChange.bind(this)(value);

	// }

	// private _runOnBlurElement(formElement) {
	// 	const value = this._runEvent(formElement, 'onBlur');
	// 	if (value === undefined) {
	// 		return;
	// 	}
	// 	formElement.onBlur.bind(this)(value);
	// }

	// onChange(event) {
	// 	if (event.name) {
	// 		this.value[event.name] = event.value;
	// 		const formElement = this.formElements.find(
	// 			element => element.name === event.name
	// 		);
	// 		if (formElement) {
	// 			this._runOnChangeElement(formElement);
	// 		}
	// 		this.change.emit();
	// 	}
	// }

	onElementInputChange() {
		this.change.emit();
	}

	// onBlur(event) {
	// 	if (event.name) {
	// 		const formElement = this.formElements.find(
	// 			element => element.name === event.name
	// 		);
	// 		if (formElement) {
	// 			this._runOnBlurElement(formElement);
	// 		}
	// 	}
	// }

	private _createFormGroup(formElements: any[]) {
		// const group = this.createFormGroupObject(formElements);
		const { group, formBuildComplete } = DFormHelpers.createFormGroupObject(formElements, this.disable);
		this.formBuildComplete = formBuildComplete || this.formBuildComplete;
		const formGroup = this.formBuilder.group(group);
		this.formElements.forEach(formElement => {
			formElement.formGroup = formGroup;
		});
		return formGroup;
	}

	ngDoCheck() {
		this.cdr.detectChanges();
	}
}
